import { EntityModel } from '@/interfaces'
import {
  ALL_FORMS_QUERY,
  CREATE_FORM_MUTATION,
  DELETE_FORM_MUTATION,
  FORCE_DELETE_FORM_MUTATION,
  SINGLE_FORM_QUERY,
  UPDATE_FORM_MUTATION,
} from './graphql'
import customBookingFormFieldEntity from '@/entities/customBookingFormField/entity'

const customBookingFormModel: EntityModel = {
  name: 'form',
  namePlural: 'forms',
  uniqueName: 'customBookingForm',
  uniqueNamePlural: 'customBookingForm',
  path: 'travel/booking/custom_data/form',
  baseUrl: '/travel/booking/custom_data/forms',
  translationPrefix: 'entities:customBookingForm.',
  getDisplayName: (values: any) => {
    return 'CUSTOM BOOKING FORM'
  },
  gql: {
    getAll: ALL_FORMS_QUERY,
    getSingle: SINGLE_FORM_QUERY,
    create: CREATE_FORM_MUTATION,
    update: UPDATE_FORM_MUTATION,
    delete: DELETE_FORM_MUTATION,
    forceDelete: FORCE_DELETE_FORM_MUTATION,
  },
  attributes: {
    fields: {
      name: 'fields',
      label: 'entities:customBookingForm.attributes.fields.label',
      type: 'entityCollection',
      dataType: '[any]',
      getEntity: () => {
        return customBookingFormFieldEntity
      },
      defaultInput: false,
      inputType: 'text',
      validationType: 'string',
      validations: [],
    },
  },
}

export default customBookingFormModel
